import { render, staticRenderFns } from "./CustomerOrderList.vue?vue&type=template&id=51743e73&scoped=true"
import script from "./CustomerOrderList.vue?vue&type=script&lang=js"
export * from "./CustomerOrderList.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrderList.vue?vue&type=style&index=0&id=51743e73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51743e73",
  null
  
)

export default component.exports